export default "/_next/static/images/f2/resultsTablet-f2dbda196da7149bb17490f6a19f6c2d.jpg";